import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { SkilledNeedsQuestionnaireItem } from './questionnaire'

export const SKILLED_NEEDS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [SkilledNeedsQuestionnaireItem.SKILLED_NEEDS]: QuestionnaireAnswerType.GROUP,
  [SkilledNeedsQuestionnaireItem.SKILLED_NEEDS_NEED]: QuestionnaireAnswerType.GROUP,
  [SkilledNeedsQuestionnaireItem.SKILLED_NEEDS_NEED_NAME]: QuestionnaireAnswerType.STRING,
  [SkilledNeedsQuestionnaireItem.SKILLED_NEEDS_NEED_SCORE]: QuestionnaireAnswerType.STRING,
  [SkilledNeedsQuestionnaireItem.SKILLED_NEEDS_NEED_PREVIOUS_NOTE]: QuestionnaireAnswerType.STRING,
  [SkilledNeedsQuestionnaireItem.SKILLED_NEEDS_NEED_NOTE]: QuestionnaireAnswerType.STRING
}
